import { render } from "./customerManagement.vue?vue&type=template&id=6b5f72e2&scoped=true"
import script from "./customerManagement.vue?vue&type=script&lang=js"
export * from "./customerManagement.vue?vue&type=script&lang=js"

import "./customerManagement.vue?vue&type=style&index=0&id=6b5f72e2&scoped=true&lang=css"

import exportComponent from "D:\\Programming_And_Stuff\\Programming\\VueJs\\food-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5f72e2"]])

export default __exports__